<div class="row mt-3" *ngIf="erro && !carregando">
  <div class="col-lg-12">
    <nb-card class="card-erro">
      <nb-card-body>{{ erro }}</nb-card-body>
    </nb-card>
  </div>
</div>

<div class="row mt-3" *ngIf="carregando">
  <div class="col-lg-12">
    <nb-card>
      <nb-card-body class="carregando-box">
        <nb-spinner status="primary"></nb-spinner>
        <span>Carregando faltas consolidadas…</span>
      </nb-card-body>
    </nb-card>
  </div>
</div>

<div class="row mt-3" *ngIf="dados && !carregando">
  <div class="col-lg-12">
    <p class="toolbar-top">
      <button nbButton size="small" status="basic" outline type="button" (click)="irFrequenciaDia()">
        <nb-icon pack="eva" icon="calendar-outline"></nb-icon>
        Ir para frequência (por data)
      </button>
      <button nbButton size="small" status="basic" ghost type="button" (click)="carregar()" class="btn-atualizar">
        <nb-icon pack="eva" icon="refresh-outline"></nb-icon>
        Atualizar
      </button>
      <button
        nbButton
        size="small"
        status="basic"
        ghost
        type="button"
        class="btn-atualizar"
        [attr.aria-expanded]="editorAberto"
        (click)="alternarEditor()"
      >
        <nb-icon pack="eva" [icon]="editorAberto ? 'chevron-up-outline' : 'message-square-outline'"></nb-icon>
        {{ editorAberto ? 'Fechar mensagem' : 'Editar mensagem' }}
      </button>
    </p>

    <nb-card class="card-mensagem" *ngIf="editorAberto">
      <nb-card-header>Mensagem do WhatsApp</nb-card-header>
      <nb-card-body>
        <p class="mensagem-ajuda">
          Vale para todas as turmas e fica salva <strong>neste navegador</strong>. Clique num marcador
          para inseri-lo no texto.
        </p>

        <div class="tokens">
          <button
            *ngFor="let t of tokens"
            type="button"
            class="token"
            [title]="t.descricao"
            (click)="inserirToken(t.token)"
          >
            {{ t.token }}
          </button>
        </div>

        <textarea
          #editorMensagem
          nbInput
          fullWidth
          rows="9"
          class="campo-mensagem"
          [(ngModel)]="mensagem"
          aria-label="Texto da mensagem enviada pelo WhatsApp"
        ></textarea>

        <div class="mensagem-acoes">
          <button nbButton size="small" status="primary" type="button" (click)="salvarMensagem()">
            <nb-icon pack="eva" icon="save-outline"></nb-icon>
            Salvar
          </button>
          <button nbButton size="small" status="basic" outline type="button" (click)="restaurarMensagemPadrao()">
            <nb-icon pack="eva" icon="undo-outline"></nb-icon>
            Restaurar padrão
          </button>
        </div>

        <div class="previa">
          <span class="previa-titulo">Como fica para {{ nomeExemploPrevia }}</span>
          <pre class="previa-texto">{{ previaMensagem }}</pre>
        </div>
      </nb-card-body>
    </nb-card>
    <nb-card>
      <nb-card-header>
        <div class="cabecalho-frequencia">
          <div>
            <span class="subtitulo">Faltas consolidadas da turma</span>
            <h3 class="nome-turma">{{ dados.turmaNome || 'Turma ' + turmaId }}</h3>
            <span class="data-leg" *ngIf="dados.frequenciaMissa"
              >Itinerário com frequência em missa (esta tela considera só o encontro).</span
            >
          </div>
          <div class="resumo">
            <span
              ><strong>{{ totalMatriculados }}</strong> matriculados</span
            >
            <span class="sep">·</span>
            <span
              ><strong>{{ comFaltaRegistrada }}</strong> com falta no encontro</span
            >
            <span class="sep">·</span>
            <span
              ><strong>{{ somaFaltas }}</strong> faltas no total</span
            >
          </div>
        </div>
      </nb-card-header>
      <nb-card-body>
        <div class="tabela-scroll">
          <table class="table table-faltas-consolidado">
            <thead>
              <tr>
                <th class="th-num">#</th>
                <th class="th-nome">Nome</th>
                <th class="th-faltas">Total de faltas<br /><span class="th-hint">(encontro)</span></th>
                <th class="th-ultima">Última frequência</th>
                <th class="th-wa">WhatsApp</th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="let m of dados.matriculados; let i = index"
                [class.linha-par]="i % 2 === 0"
                [class.linha-impar]="i % 2 !== 0"
              >
                <td class="cel-numero" data-label="#">{{ i + 1 }}</td>
                <td class="cel-nome" data-label="Nome">{{ m.pessoaNome }}</td>
                <td class="cel-faltas" data-label="Total de faltas">
                  <button
                    type="button"
                    class="badge-faltas"
                    [class.zero]="m.totalFaltas === 0"
                    [disabled]="!m.totalFaltas || !m.pessoaId"
                    [attr.title]="m.totalFaltas ? 'Ver os dias de falta de ' + (m.pessoaNome || '') : 'Sem faltas registradas'"
                    [attr.aria-label]="m.totalFaltas ? 'Ver os dias de falta de ' + (m.pessoaNome || '') : 'Sem faltas registradas'"
                    (click)="abrirDatasFaltas(m)"
                  >
                    {{ m.totalFaltas }}
                  </button>
                </td>
                <td class="cel-ultima" data-label="Última frequência">
                  <ng-container *ngIf="parseIsoData(m.dataUltimoRegistro) as dt; else semRegistro">
                    <div class="ultima-linha">
                      <span class="ultima-data">{{ dt | date: 'dd/MM/yyyy' }}</span>
                      <span class="tag-falta-ultima" *ngIf="m.faltouUltimoEncontro">Faltou no último encontro</span>
                      <span class="tag-ok-ultima" *ngIf="!m.faltouUltimoEncontro">Presente no último</span>
                    </div>
                  </ng-container>
                  <ng-template #semRegistro>
                    <span class="sem-registro">Sem registro de frequência</span>
                  </ng-template>
                </td>
                <td class="cel-wa" data-label="WhatsApp">
                  <a
                    *ngIf="linkWhatsappMatriculado(m) as waUrl"
                    nbButton
                    size="small"
                    appearance="outline"
                    status="success"
                    class="link-wa"
                    [href]="waUrl"
                    target="_blank"
                    rel="noopener noreferrer"
                    title="Enviar mensagem no WhatsApp"
                  >
                    <nb-icon pack="eva" icon="message-circle-outline"></nb-icon>
                    WhatsApp
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="fim-scroll-bar" aria-hidden="true"></div>
        </div>
      </nb-card-body>
    </nb-card>
  </div>
</div>
